export const ELASTICITY_COEFFICIENT = 'elasticity_coefficient';
